import {
  MessageTypeEnum,
  MessageStatusEnum,
  DeliveryStatusEnum
} from '../enums';

export interface BroadcastMessage {
  id: string;
  type: MessageTypeEnum;
  subject: string;
  message: string;
  status: MessageStatusEnum;
  scheduledAt?: string | null;
  sentAt?: string | null;
  totalRecipients: number;
  successfulCount: number;
  failedCount: number;
  targetAllUsers: boolean;
  targetStateCodes?: string[];
  targetRoles?: string[];
  targetUserIds?: string[];
  targetFacilityIds?: string[];
  createdBy: string;
  createdByName: string;
  createdAt: string;
  recipients?: MessageRecipient[];
}

export interface MessageRecipient {
  userId: string;
  userName: string;
  userEmail: string;
  emailDeliveryStatus?: string;
  notificationDeliveryStatus?: string;
  errorMessage?: string;
  sentAt?: string;
}

export interface CreateBroadcastMessageDto {
  type: MessageTypeEnum;
  sendToUsers?: string[];
  sendToStates?: string[];
  sendToFacilityIds?: string[];
  sendToRoles?: string[];
  subject: string;
  message: string;
  scheduleTo?: string | null;
  saveAsDraft?: boolean;
}

export interface UpdateBroadcastMessageDto {
  type?: MessageTypeEnum;
  sendToUsers?: string[];
  sendToFacilityIds?: string[];
  sendToStates?: string[];
  sendToRoles?: string[];
  subject?: string;
  message?: string;
  scheduleTo?: string | null;
  saveAsDraft?: boolean;
}

export interface BroadcastMessageListItem {
  id: string;
  type: MessageTypeEnum;
  subject: string;
  numberOfContacts: number;
  sentAt?: string | null;
  scheduledAt?: string | null;
  status: MessageStatusEnum;
  createdAt: string;
}

export interface BroadcastMessageSearchDto {
  searchText?: string;
  type?: MessageTypeEnum;
  stateCodes?: string[];
  statuses?: MessageStatusEnum[];
  deliveryStatus?: DeliveryStatusEnum;
  pageNumber?: number;
  pageSize?: number;
}

export interface PreviewRecipientsDto {
  type: MessageTypeEnum;
  subject: string;
  message: string;
  sendToUsers?: string[];
  sendToFacilityIds?: string[];
  sendToStates?: string[];
  sendToRoles?: string[];
}

export interface PreviewRecipientsResponse {
  totalCount: number;
  byRole: Record<string, number>;
  byState: Record<string, number>;
}
